import { produce } from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { storeName as layoutModelStore } from '../models/layout.model';
import { storeName as projectModelStore } from '../models/project.model';
import { TemplateCategoryTypes } from '../../types';
import { getProjectTemplateCategories } from '../../services/project.service';
import { TemplateCategoryResponseTypes } from '../../types/response';
import { convertTemplateCategoryResponse } from '../../utils/convertUtils/templateCategory';

export const storeName = 'templateCategoryEntity';

export const templateCategoryEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: TemplateCategoryTypes[]) => {
      (entities || []).forEach((entity) => {
        state.ids[entity.code] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof templateCategoryEntity>) => ({
    async loadByProjectKey(_, state: RootModel) {
      const { locale } = state[layoutModelStore];
      const { projectCode } = state[projectModelStore];

      if (!projectCode) return;
      const resp: TemplateCategoryResponseTypes[] = await getProjectTemplateCategories(
        projectCode,
        locale.apiLanguage
      );

      if (!resp) return;

      const templateCategories = resp.map((i) => convertTemplateCategoryResponse(i));

      this.saves(templateCategories);
    },
  }),
});

export default templateCategoryEntity;
